const translations = {
    notFound: `We're sorry, there was an error in retrieving your {{resourceName}}.`
};

export default translations;
